export default __webpack_public_path__ + "static/media/claim.5a120843.svg";